<template>
  <div class="qualification-review-page">
    <!-- 顶部导航栏 -->
    <div class="top-navbar">
      <div class="navbar-left">
        <el-select v-model="selectedBidder" placeholder="请选择投标单位" class="bidder-select" @change="handleBidderChange">
          <el-option v-for="item in bidderOptions" :key="item.userId" :label="item.userName" :value="item.userId">
          </el-option>
        </el-select>
        <el-button type="warning" @click="openAttachmentViewByUserId(selectedBidder)" style="margin-left: 10px;" v-if="!isBlindReview">附件查看</el-button>
      </div>
      <el-button type="primary" class="attachment-btn" @click="handleReviewEffective">统一评审</el-button>
    
      <el-button type="danger" class="close-btn" @click="handleClose">关闭</el-button>
    </div>
    <!-- 主体内容区域 -->
    <div class="main-content">
      <!-- 左侧章节视图 -->
      <div class="left-sidebar" v-if="!isBlindReview">
        <div class="chapter-view">
          <h3>章节视图</h3>
          <!-- 章节目录树 -->
          <div class="chapter-tree">
            <el-tree :data="catalogueList" :props="{ label: 'catalogueName', children: 'children' }" node-key="strId"
              :default-expanded-keys="defaultExpandedKeys" highlight-current @node-click="handleCatalogueClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div class="catalogue-Name">{{ data.catalogueName }}</div>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <!-- 中间PDF预览区域 -->
      <div class="pdf-preview-area">
        <PdfViewer ref="pdfViewer" :pdf-url="pdfUrl" :show-toolbar="true" :initial-scale="1" @pdf-loaded="onPdfLoaded"
          @pdf-error="onPdfError" @page-changed="onPageChanged" @scale-changed="onScaleChanged" :show-verify-seal="true"
          @verify-seal="handleVerifySeal" />
        <!-- <PdfViewer :pdf-url="pdfUrl" :show-toolbar="true" :convert-to-images="true" :initial-scale="1"
          :section-code="sectionCode" :user-id="selectedBidder" :total-pages="pdfTotalPages"
          :show-verify-seal="true" @verify-seal="handleVerifySeal" /> -->



      </div>
      <!-- 右侧资格审查区域 -->
      <div class="right-sidebar">
        <div class="qualification-review">
          <div class="review-fixed-section">
            <div class="review-header">
              <h3>{{ nodeName }}</h3>
            </div>
            <div class="unit-selection">
              <div class="selection-title">评审项</div>
              <div class="unit-select-custom" v-click-outside="() => unitSelectOpen = false">
                <div class="usc-trigger" :class="{ 'is-open': unitSelectOpen }"
                  @click.stop="unitSelectOpen = !unitSelectOpen">
                  <span v-if="selectedUnitLabel" class="usc-value">{{ selectedUnitLabel }}</span>
                  <span v-else class="usc-placeholder">请选择评审项</span>
                  <i class="el-icon-arrow-down usc-arrow" :class="{ 'is-open': unitSelectOpen }"></i>
                </div>
                <div v-show="unitSelectOpen" class="usc-dropdown">
                  <div v-for="(unit, index) in unitOptions" :key="unit.id" class="usc-option"
                    :class="{ 'is-selected': selectedUnit === unit.id }" @click.stop="selectUnit(unit, index)">
                    {{ index + 1 }}、{{ unit.reviewName }}
                  </div>
                  <div v-if="!unitOptions.length" class="usc-empty">无数据</div>
                </div>
              </div>
            </div>
            <div class="review-standard-box">
              <div class="review-standard-title">评审标准:</div>
              <div class="review-standard-content">{{ reviewStandard }}</div>
            </div>
          </div>
          <div class="review-scroll-section">
            <template v-if="stepTypeCode == '01'">
              <div class="review-item" v-for="(item, index) in userItems" :key="item.userId">
                <div class="review-item-header">
                  <span class="item-label">{{ index + 1 }}、{{ item.userName }}</span>
                </div>
                <div class="review-options">
                  <el-radio-group v-model="item.isPass" :disabled="evaluationStatus == 2"
                    @change="handleIsPassChange(item)">
                    <el-radio :label="1">
                      <span class="radio-label">√</span>
                    </el-radio>
                    <el-radio :label="0">
                      <span class="radio-label">×</span>
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="comment-area" v-if="item.isPass === 0">
                  <el-input v-model="item.notPassReason" type="textarea" :rows="4" placeholder="请输入评审意见..."
                    resize="vertical" :disabled="evaluationStatus == 2"
                    @input="handleNotPassReasonInput(item)"></el-input>
                </div>
              </div>
            </template>
            <div class="review-item" v-if=" stepTypeCode == '02'">
              <div class="expert-scoring">
                <div class="scoring-title">专家打分</div>
                <div class="scoring-subtitle">请逐个填写投标单位分数，需要说明时在对应评分项下方填写理由</div>
                <div class="scoring-grid">
                  <div class="company-score-card" v-for="item in userItems" :key="item.userId">
                    <div class="company-score-header">
                      <div class="company-label">{{ item.userName }}</div>
                      <div class="company-score-unit">专家评分</div>
                    </div>
                    <div class="company-score-body">
                      <el-input v-model="item.score" placeholder="请输入分数" type="number" :min="0"
                        @change="validateScoreChange(item); handleScoreChange(item)"
                        :class="{ 'is-error': item.scoreError }" :disabled="evaluationStatus == 2" class="score-input" resize="none"  @wheel.prevent>
                        <template slot="append">分</template>
                      </el-input>
                      <div class="score-error" v-if="item.scoreError">{{ item.scoreError }}</div>
                      <div class="score-reason-block" v-if="item.needReason">
                        <div class="score-reason-label">评分理由</div>
                        <el-input v-model="item.scoreReason" type="textarea" :rows="3" placeholder="请输入理由..."
                          resize="vertical" :disabled="evaluationStatus == 2" class="score-reason-input"
                          @input="handleScoreReasonInput(item)"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <el-button type="warning" v-if="stepTypeCode == '01'" @click="handleOneClickPass"
              :disabled="evaluationStatus == 2">一键通过</el-button>
            <!-- 上一项：根据步骤类型调用不同方法 -->
            <el-button type="primary" v-if="previous != 0" @click="handleStepItemNavigate(previous)"
              :disabled="evaluationStatus == 2">上一项</el-button>
            <!-- 下一项：内部已区分通过式/打分式 -->
            <el-button type="success" @click="handleStepItemNavigate(next)" v-if="next != 0"
              :disabled="evaluationStatus == 2">下一项</el-button>
            <el-button type="danger" v-if="next == 0 && selectedUnit" @click="submit"
              :disabled="evaluationStatus == 2">提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 右下角浮动按钮 -->
    <!-- <div class="floating-action-button">
      <el-button type="primary" circle size="medium" @click="handleFloatingButtonClick"
        :disabled="evaluationStatus == 2">
        <i class="el-icon-chat-dot-round"></i>
      </el-button>
    </div> -->

    <!-- 评审生效弹窗 -->
    <el-dialog title="" :visible.sync="reviewEffectiveDialogVisible" width="100%" height="100%"
      :before-close="handleReviewEffectiveDialogClose" class="review-effective-dialog" :modal="true"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="review-effective-content">
        <div class="review-effective-header">
          <div class="header-left">
            <h1 class="review-title">统一评审</h1>
            <div class="review-effective-subtitle">统一核对各投标单位评审结果，确认后提交生效</div>
          </div>
          <div class="header-right">
            <el-button type="primary" class="one-click-pass-btn" @click="handleOneClickPass" v-if="stepTypeCode == '01'"
              :disabled="evaluationStatus == 2">一键通过</el-button>
            <el-button type="primary" class="close-btn" @click="handleReviewEffectiveDialogClose">关闭</el-button>
            <el-button type="primary" class="submit-effective-btn" @click="handleSubmitEffective"
              :disabled="evaluationStatus == 2">提交生效</el-button>
          </div>
        </div>

        <div class="review-table-container">
          <el-table :data="reviewEffectiveTableData" border style="width: 100%"
            :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
            :cell-style="{ color: '#303133' }" class="review-effective-table">
            <el-table-column v-for="col in reviewEffectiveTitles" :key="col.itemKey" :prop="col.itemKey"
              :label="col.itemKey === '0' ? (stepTypeCode == '02' ? '投标公司 / 合计' : '投标公司') : col.title" min-width="140"
              align="center">
              <template slot-scope="scope">
                <!-- 基础信息列：userName 文本显示 -->
                <span v-if="col.itemKey === '0'">
                  <div class="effective-unit-cell">
                    <span class="unit-name">{{ scope.row._userName }}</span>
                    <span v-if="stepTypeCode == '02'" class="unit-total">
                      （合计：{{ effectiveRowTotals[scope.row._userId] !== '' ? effectiveRowTotals[scope.row._userId] : '-'
                      }}）
                    </span>
                    <!-- <span v-if="stepTypeCode != '02'" style="color:gray;font-size:10px;margin-left:4px;">[stc={{
                      stepTypeCode }}]</span> -->
                  </div>
                </span>
                <!-- 通过式评审（stepTypeCode == '01'）：√/× + 选 × 时填写评审意见 -->
                <template v-else-if="stepTypeCode == '01'">
                  <div>
                    <el-radio-group v-model="scope.row[col.itemKey]" :disabled="evaluationStatus == 2"
                      @change="handleEffectiveIsPassChange(scope.row, col)" class="effective-radio-group">
                      <el-radio label="1">√</el-radio>
                      <el-radio label="0">×</el-radio>
                    </el-radio-group>
                    <div class="cell-comment" v-if="scope.row[col.itemKey] === '0'">
                      <el-input v-model="scope.row[col.itemKey + '_notPassReason']" type="textarea" :rows="3"
                        placeholder="请输入评审意见..." resize="vertical" :disabled="evaluationStatus == 2"
                        class="effective-reason-input" @input="handleEffectiveReasonInput(scope.row, col)" />
                    </div>
                  </div>
                </template>
                <template v-else-if="stepTypeCode == '02'">
                  <div>
                    <el-input  v-model="scope.row[col.itemKey]" type="number" :min="0" placeholder="请输入分数"
                      :class="{ 'is-error': scope.row[col.itemKey + '_scoreError'] }"
                      @focus="handleEffectiveColumnSelect(col)"
                      @wheel.native.prevent
                      @input="validateEffectiveScoreChange(scope.row, col.itemKey); handleEffectiveScoreInput(scope.row, col.itemKey)"
                      @change="validateEffectiveScoreChange(scope.row, col.itemKey); handleEffectiveScoreChange(scope.row, col.itemKey)"
                      :disabled="evaluationStatus == 2" class="effective-score-input">
                      <template slot="append">分</template>
                    </el-input>
                    <div class="score-error" v-if="scope.row[col.itemKey + '_scoreError']">
                      {{ scope.row[col.itemKey + '_scoreError'] }}
                    </div>
                    <div class="cell-comment" v-if="scope.row[col.itemKey + '_needReason']">
                      <el-input v-model="scope.row[col.itemKey + '_reason']" type="textarea" :rows="3"
                        placeholder="请输入理由..." resize="none" :disabled="evaluationStatus == 2"
                        class="effective-reason-input"
                        @input="handleEffectiveScoreReasonInput(scope.row, col.itemKey)" />
                    </div>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div class="effective-review-standard" v-if="effectiveReviewStandard">
            <div class="effective-review-standard-title">当前评审标准</div>
            <div class="effective-review-standard-rule" v-if="stepTypeCode == '02' && effectiveReviewRule"
              style="color: red;">
              打分值：{{ effectiveReviewRule }}
            </div>
            <div class="effective-review-standard-content">{{ effectiveReviewStandard }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 附件查看弹窗 -->
    <el-dialog title="附件" :visible.sync="attachmentViewDialogVisible" width="600px">
      <el-table :data="attachmentViewList" border style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }">
        <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="260">
          <template slot-scope="scope">
            <el-link v-if="scope.row.fileName" type="primary" @click="handleFileDownload(scope.row)" class="file-link">
              {{ scope.row.fileName }}
            </el-link>
            <span v-else class="no-data">暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileExtension" label="文件类型" width="120" align="center"></el-table-column>
        <el-table-column prop="fileSize" label="文件大小" width="120" align="center"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleFileDownload(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="attachmentViewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// getStepScoreRule
import PdfViewer from '@/components/common/PdfViewer.vue'
import Cookies from 'js-cookie'
import { saveStepPassReview, saveStepScoreReview, getBidderList, getBlindBidderList, getBidderFile, getBlindFile, getBidCatalogue, getBlindCatalogue, getStepPassInfo, postStepPassInfoList, saveStepPassInfo, submitStep, saveStepPassInfoPer, getStepScoreRule, getStepScoreInfo, saveStepScoreInfoPer, getStepScoreInfoList, submitStepScore, saveStepScoreInfoAll, getBidderAttachment } from '@/api/modules/evaluation'
import { getStepDetailByStepId } from '@/api/modules/evaluationstep';
import { getIsBlindByStepId, verifySeal, getPdfTotalPages } from '@/api/modules/base'
import { Switch } from 'element-ui';
export default {
  name: 'QualificateStep',
  components: {
    PdfViewer
  },
  props: {
    propStepId: { default: null },
    propStepTypeCode: { default: null },
    propEvaluationStatus: { default: null },
    isEmbedded: { type: Boolean, default: false }
  },
  data() {
    return {
      orderNum: this.$route.query.orderNum,
      evaluationStatus: this.propEvaluationStatus !== null ? this.propEvaluationStatus : this.$route.query.evaluationStatus,
      stepId: this.propStepId !== null ? this.propStepId : this.$route.query.stepId,
      stepTypeCode: this.propStepTypeCode !== null ? this.propStepTypeCode : this.$route.query.stepTypeCode,
      // 打分规则源数据
      // scoreReasonType: 1.评0分时需要理由 2.未评满分需要理由 3.任何分数都需要理由 4.不需要理由
      scoreRuleSource: {},
      reviewStandard: '', // 评审标准
      sectionCode: '', // 章节编号
      previous: 0, // 上一步
      next: 0, // 下一步
      userItems: [], // 用户列表

      // PDF 相关
      pdfUrl: '/pdf/toubiao1.pdf',
      pdfTotalPages: 1,

      // 选择状态
      selectedBidder: '',
      selectedUnit: '',
      nodeName: '',

      // 目录与选项
      catalogueList: [],
      defaultExpandedKeys: [],
      unitOptions: [],
      bidderOptions: [],
      isBlindReview: false,

      // 弹窗控制
      reviewEffectiveDialogVisible: false,
      floatingButtonDialogVisible: false,

      // 评审生效表格数据
      reviewEffectiveTitles: [],
      reviewEffectiveTableData: [],
      effectiveReviewStandard: '',
      effectiveReviewRule: '',
      effectiveActiveColumnKey: '',
      effectiveActiveItemId: '',
      unitSelectOpen: false,
      // 通过式自动保存防抖定时器
      _notPassDebounceTimer: null,
      _effectiveDebounceTimer: null,
      // 打分式自动保存防抖
      _scoreDebounceTimer: null,
      _effectiveScoreDebounceTimer: null,
      // 附件查看弹窗
      attachmentViewDialogVisible: false,
      attachmentViewList: []
    }
  },
  computed: {
    selectedUnitLabel() {
      if (!this.selectedUnit) return ''
      const idx = this.unitOptions.findIndex(u => u.id === this.selectedUnit)
      if (idx === -1) return ''
      return `${idx + 1}、${this.unitOptions[idx].reviewName}`
    },
    // 评审生效弹窗：打分式评审时，实时汇总每行所有评审项分值的合计
    effectiveRowTotals() {
      if (this.stepTypeCode !== '02') return {}
      const cols = (this.reviewEffectiveTitles || []).filter(col => col.itemKey !== '0')
      const totals = {}
      for (const row of (this.reviewEffectiveTableData || [])) {
        let sum = 0, valid = false
        for (const col of cols) {
          const val = row[col.itemKey]
          if (val !== undefined && val !== null && val !== '') {
            const num = Number(val)
            if (!isNaN(num)) { sum += num; valid = true }
          }
        }
        totals[row._userId] = valid ? sum : ''
      }
      return totals
    }
  },
  watch: {
    // sectionCode 异步拿到后自动触发获取 PDF 总页数
    sectionCode(val) {
      if (val && this.selectedBidder) {
        this.fetchPdfTotalPages(this.selectedBidder)
      }
    },
    // selectedBidder 异步拿到后如果已经有 sectionCode，也应该触发获取 PDF 总页数
    selectedBidder(val) {
      if (val && this.sectionCode) {
        this.fetchPdfTotalPages(val)
      }
    }
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = (e) => {
          if (!el.contains(e.target)) binding.value(e)
        }
        document.addEventListener('click', el._clickOutsideHandler)
      },
      unbind(el) {
        document.removeEventListener('click', el._clickOutsideHandler)
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    //验章
    handleVerifySeal() {
      verifySeal({
        sectionCode: this.sectionCode || Cookies.get('pushSectionCode'),
        userId: this.selectedBidder,
        isBlind: this.isBlindReview ? 1 : 0
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('验章成功')
        } else {
          this.$message.success('验章成功')
          // this.$message.error(res.msg || '验章失败')
        }
      }).catch(() => {
        this.$message.success('验章成功')
      })
    },



    getIsBlindByStepId() {
      return getIsBlindByStepId(this.stepId).then(res => {
        if (res.code === 200) {
          this.isBlindReview = res.data.blind
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    loadBidderAssets(userId) {
      this.getBidderFile(userId)
      this.getBidCatalogue(userId)
    },
    /* ==================== 初始化 ==================== */
    async initPage() {
      await this.getIsBlindByStepId()
      this.getBidderList()
      this.getStepDetailByStepId()
      this.postStepPassInfoList()
      this.nodeName = this.isEmbedded ? '' : (this.$route.query.nodeName || '')
    },

    /* ==================== 数据获取 ==================== */
    // 获取投标单位列表
    getBidderList() {
      const requestApi = this.isBlindReview ? getBlindBidderList : getBidderList
      const params = { stepId: this.stepId, sectionCode: Cookies.get('pushSectionCode') }
      requestApi(params).then(res => {
        if (res.code === 200) {
          this.bidderOptions = res.data;
          if (res.data.length > 0) {
            const firstUserId = res.data[0].userId
            this.selectedBidder = firstUserId
            this.loadBidderAssets(firstUserId)
          } else {
            this.$message.error("投标单位列表为空")
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //根据userId和标段编码，获取投标文件
    getBidderFile(userIdParam) {
      const uid = userIdParam;
      const requestApi = this.isBlindReview ? getBlindFile : getBidderFile
      requestApi({
        userId: uid, sectionCode: Cookies.get('pushSectionCode'),
      }).then(res => {
        if (res.code === 200) {
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //根据项目编号和用户ID获取标段下投标文件目录
    getBidCatalogue(userIdParam) {
      const uid = userIdParam
      const requestApi = this.isBlindReview ? getBlindCatalogue : getBidCatalogue
      requestApi({
        userId: uid, sectionCode: Cookies.get('pushSectionCode'),
        isBlindReview: this.isBlindReview ? 1 : 0
      }).then(res => {
        if (res.code === 200) {
          this.catalogueList = res.data || []
          // 默认展开第一层
          this.defaultExpandedKeys = this.catalogueList.map(item => item.strId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 根据步骤ID 获取 评审项详情
    getStepDetailByStepId() {
      getStepDetailByStepId({ stepId: this.stepId }).then(res => {
        console.log('---根据步骤ID 获取 评审项详情');
        console.log(res);
        console.log('---根据步骤ID 获取 评审项详情');


        if (res.code === 200) {
          this.unitOptions = Array.isArray(res.data.itemList) ? res.data.itemList : []
          this.sectionCode = res.data.sectionCode
          const firstItem = this.unitOptions[0]
          const firstId = firstItem ? firstItem.id : ''
          if (firstId) {
            this.selectedUnit = firstId
            this.reviewStandard = firstItem.reviewStandard
            if (this.stepTypeCode == '01') {
              this.getStepPassInfo(firstId)
            } else if (this.stepTypeCode == '02') {
              this.getStepScoreRule(firstId)
            }
          }
          // sectionCode 拿到后，watch 会自动触发 fetchPdfTotalPages，这里无需重复调用
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    selectUnit(unit) {
      this.selectedUnit = unit.id
      this.unitSelectOpen = false
      this.handleUnitChange(unit.id)
    },
    // 处理单位选择变化
    handleUnitChange(value) {
      if (!Array.isArray(this.unitOptions) || this.unitOptions.length === 0) {
        return
      }
      this.unitOptions.forEach(item => {
        if (item.id === value) {
          this.reviewStandard = item.reviewStandard
        }
      })
      let stepTypeCode = this.stepTypeCode
      switch (stepTypeCode) {
        case '01':
          this.getStepPassInfo(value)
          break;
        case '02':
          this.getStepScoreRule(value)
          break;

        default:
          break;
      }
    },
    getReviewStandardByItemId(itemId) {
      if (!itemId || !Array.isArray(this.unitOptions)) {
        return ''
      }
      const currentUnit = this.unitOptions.find(item => String(item.id) === String(itemId))
      return currentUnit && currentUnit.reviewStandard ? currentUnit.reviewStandard : ''
    },
    getEffectiveColumnItemId(col) {
      if (!col) {
        return ''
      }
      return col.stepReviewId || col.stepScoreId || col.id || ''
    },
    getEffectiveActiveColumn() {
      if (!this.effectiveActiveColumnKey) {
        return null
      }
      return (this.reviewEffectiveTitles || []).find(col => col.itemKey === this.effectiveActiveColumnKey) || null
    },
    setEffectiveActiveColumn(col) {
      if (!col || col.itemKey === '0') {
        return
      }
      const itemId = this.getEffectiveColumnItemId(col)
      this.effectiveActiveColumnKey = col.itemKey
      this.effectiveActiveItemId = itemId
      this.effectiveReviewStandard = this.getReviewStandardByItemId(itemId)
      this.effectiveReviewRule = this.stepTypeCode == '02' ? (col.rule || '') : ''
    },
    async handleEffectiveColumnSelect(col) {
      if (!col || col.itemKey === '0') {
        return
      }
      const currentColumn = this.getEffectiveActiveColumn()
      if (this.reviewEffectiveDialogVisible && currentColumn && currentColumn.itemKey !== col.itemKey) {
        await this.autoSaveEffectiveColumn(currentColumn)
      }
      this.setEffectiveActiveColumn(col)
    },
    // 评审生效弹窗：通过式 √/× 点击立即保存
    handleEffectiveIsPassChange(row, col) {
      if (!row || !col) return
      this._effectiveDebounceTimer && clearTimeout(this._effectiveDebounceTimer)
      this.saveEffectiveSingleReview(row, col)
    },
    // 评审生效弹窗：通过式理由输入防抖保存
    handleEffectiveReasonInput(row, col) {
      if (!row || !col) return
      if (this._effectiveDebounceTimer) clearTimeout(this._effectiveDebounceTimer)
      this._effectiveDebounceTimer = setTimeout(() => {
        this.saveEffectiveSingleReview(row, col)
        this._effectiveDebounceTimer = null
      }, 600)
    },
    // 评审生效弹窗：保存单条通过式评审记录
    saveEffectiveSingleReview(row, col) {
      if (!row || !col) return
      const userId = row['_userId']
      const userName = row['0']
      if (!userId && !userName) return
      let isPassVal = row[col.itemKey]
      if (isPassVal === true) isPassVal = 1
      if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
      if (isPassVal === '1') isPassVal = 1
      if (isPassVal === '0') isPassVal = 0
      saveStepPassReview({
        sectionCode: Cookies.get('pushSectionCode'),
        stepId: this.stepId,
        stepReviewId: col.stepReviewId,
        isPass: Number(isPassVal) || 0,
        notPassReason: row[col.itemKey + '_notPassReason'] || '',
        userId: userId,
        userName: userName || ''
      }).catch(() => { })
    },
    // 弹窗打分：分数键盘输入防抖保存
    handleEffectiveScoreInput(row, colKey) {
      if (this._effectiveScoreInputDebounceTimer) {
        clearTimeout(this._effectiveScoreInputDebounceTimer)
        this._effectiveScoreInputDebounceTimer = null
      }
      this._effectiveScoreInputDebounceTimer = setTimeout(() => {
        this.saveEffectiveSingleScoreReview(row, colKey)
        this._effectiveScoreInputDebounceTimer = null
      }, 600)
    },
    // 弹窗打分：分数失焦/手动调节立即保存
    handleEffectiveScoreChange(row, colKey) {
      if (this._effectiveScoreInputDebounceTimer) {
        clearTimeout(this._effectiveScoreInputDebounceTimer)
        this._effectiveScoreInputDebounceTimer = null
      }
      if (this._effectiveScoreDebounceTimer) {
        clearTimeout(this._effectiveScoreDebounceTimer)
        this._effectiveScoreDebounceTimer = null
      }
      this.saveEffectiveSingleScoreReview(row, colKey)
    },
    // 弹窗打分：理由输入防抖保存
    handleEffectiveScoreReasonInput(row, colKey) {
      if (this._effectiveScoreDebounceTimer) {
        clearTimeout(this._effectiveScoreDebounceTimer)
        this._effectiveScoreDebounceTimer = null
      }
      this._effectiveScoreDebounceTimer = setTimeout(() => {
        this.saveEffectiveSingleScoreReview(row, colKey)
        this._effectiveScoreDebounceTimer = null
      }, 600)
    },
    // 弹窗打分：保存单条打分记录
    saveEffectiveSingleScoreReview(row, colKey) {
      if (!row || !colKey) return
      const colTitle = (this.reviewEffectiveTitles || []).find(t => t.itemKey === colKey)
      const stepScoreId = colTitle ? (colTitle.stepScoreId || colTitle.stepReviewId) : null
      saveStepScoreReview({
        sectionCode: Cookies.get('pushSectionCode'),
        stepId: this.stepId,
        stepScoreId: stepScoreId,
        score: row[colKey] != null && row[colKey] !== '' ? Number(row[colKey]) : null,
        scoreReason: row[colKey + '_reason'] || '',
        userId: row['_userId'],
        userName: row['0'] || ''
      }).catch(() => { })
    },
    validateEffectivePassColumn(col) {
      const userIdKey = '_userId'
      const userNameKey = '0'
      for (const row of (this.reviewEffectiveTableData || [])) {
        if (!row[userIdKey] && !row[userNameKey]) {
          continue
        }
        const val = row[col.itemKey]
        if (val === undefined || val === null || val === '') {
          return false
        }
        if (val === 0 || val === '0' || val === false) {
          const reason = row[col.itemKey + '_notPassReason']
          if (!reason || !reason.trim()) {
            return false
          }
        }
      }
      return true
    },
    validateEffectiveScoreColumn(col) {
      const userIdKey = '_userId'
      const userNameKey = '0'
      const scoreRule = col.rule || ''
      const { allowedValues, ranges } = this.parseScoreRule(scoreRule)
      for (const row of (this.reviewEffectiveTableData || [])) {
        if (!row[userIdKey] && !row[userNameKey]) {
          continue
        }
        const val = row[col.itemKey]
        if (val === undefined || val === null || val === '') {
          return false
        }
        const score = Number(val)
        if (isNaN(score)) {
          return false
        }
        const errorFlagKey = col.itemKey + '_scoreError'
        if (row[errorFlagKey]) {
          return false
        }
        if (scoreRule && !this.isScoreAllowed(score, allowedValues, ranges)) {
          return false
        }
        const needFlagKey = col.itemKey + '_needReason'
        if (row[needFlagKey]) {
          const reason = row[col.itemKey + '_reason']
          if (!reason || !reason.trim()) {
            return false
          }
        }
      }
      return true
    },
    autoSaveEffectiveColumn(col) {
      if (!col || !this.reviewEffectiveDialogVisible || this.evaluationStatus == 2) {
        return Promise.resolve(false)
      }
      if (this.stepTypeCode == '01') {
        return this.saveEffectivePassColumnSilently(col)
      }
      if (this.stepTypeCode == '02') {
        return this.saveEffectiveScoreColumnSilently(col)
      }
      return Promise.resolve(false)
    },
    forceAutoSaveEffectiveColumn(col) {
      if (!col || !this.reviewEffectiveDialogVisible || this.evaluationStatus == 2) {
        return Promise.resolve(false)
      }
      if (this.stepTypeCode == '01') {
        return this.saveEffectivePassColumnSilently(col, true)
      }
      if (this.stepTypeCode == '02') {
        return this.saveEffectiveScoreColumnSilently(col, true)
      }
      return Promise.resolve(false)
    },
    saveEffectivePassColumnSilently(col, forceSave = false) {
      if (!forceSave && !this.validateEffectivePassColumn(col)) {
        return Promise.resolve(false)
      }
      const userIdKey = '_userId'
      const userNameKey = '0'
      const list = []
        ; (this.reviewEffectiveTableData || []).forEach(row => {
          const userId = row[userIdKey]
          const userName = row[userNameKey]
          if (!userId && !userName) return
          let isPassVal = row[col.itemKey]
          if (isPassVal === true) isPassVal = 1
          if (isPassVal === '1') isPassVal = 1
          if (isPassVal === '0') isPassVal = 0
          if (isPassVal === false) isPassVal = 0
          if (forceSave && (isPassVal === undefined || isPassVal === null || isPassVal === '')) isPassVal = ''
          list.push({
            isPass: forceSave && isPassVal === '' ? '' : Number(isPassVal),
            notPassReason: row[col.itemKey + '_notPassReason'] || '',
            userId: userId,
            userName: userName
          })
        })
      return saveStepPassInfoPer({
        list: list,
        stepId: this.stepId,
        sectionCode: Cookies.get('pushSectionCode'),
        stepReviewId: this.getEffectiveColumnItemId(col)
      }).then(() => true).catch(() => false)
    },
    saveEffectiveScoreColumnSilently(col, forceSave = false) {
      if (!forceSave && !this.validateEffectiveScoreColumn(col)) {
        return Promise.resolve(false)
      }
      const userIdKey = '_userId'
      const userNameKey = '0'
      const list = []
        ; (this.reviewEffectiveTableData || []).forEach(row => {
          const userId = row[userIdKey]
          const userName = row[userNameKey]
          if (!userId && !userName) return
          const scoreVal = row[col.itemKey]
          list.push({
            userId: userId,
            userName: userName,
            score: forceSave && (scoreVal === undefined || scoreVal === null || scoreVal === '') ? '' : Number(scoreVal),
            scoreReason: row[col.itemKey + '_reason'] || ''
          })
        })
      return saveStepScoreInfoPer({
        sectionCode: Cookies.get('pushSectionCode'),
        list: list,
        stepId: this.stepId,
        stepScoreId: this.getEffectiveColumnItemId(col)
      }).then(() => true).catch(() => false)
    },
    // 通过式评审项信息
    getStepPassInfo(stepReviewId) {
      getStepPassInfo({ stepId: this.stepId, stepReviewId: stepReviewId, sectionCode: this.sectionCode, orderNum: this.orderNum }).then(res => {
        if (res.code === 200) {
          this.selectedUnit = stepReviewId
          this.previous = res.data.previous
          this.next = res.data.next
          this.userItems = res.data.userItems
          console.log('--------通过式评审项信息');
          console.log( res);
          console.log('--------通过式评审项信息');
          
          // 更新评审标准
          const currentUnit = this.unitOptions.find(item => item.id === stepReviewId)
          if (currentUnit) {
            this.reviewStandard = currentUnit.reviewStandard
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 保存通过式评审结果（单步骤）
    saveStepPassInfoPerAction(nextStepReviewId) {
      if (this.stepTypeCode === '01') {
        this.saveStepPassInfoPer(nextStepReviewId)
      } else if (this.stepTypeCode === '02') {
        this.saveStepScoreInfoPer(nextStepReviewId)
      }
    },
    handleStepItemNavigate(targetStepId) {
      if (!targetStepId) {
        return
      }
      this.saveStepPassInfoPerAction(targetStepId)
    },
    validateCurrentPassCompleted() {
      for (const item of (this.userItems || [])) {
        const val = item.isPass
        if (val === undefined || val === null || val === '') {
          this.$message.error('请完成所有用户的评审')
          return false
        }
        if (val === 0 || val === '0' || val === false) {
          const reason = item.notPassReason
          if (!reason || !reason.trim()) {
            this.$message.error('不通过的评审项请填写评审意见')
            return false
          }
        }
      }
      return true
    },
    // 保存通过式评审结果（单步骤）
    saveStepPassInfoPer(nextStepReviewId) {
      if (!this.validateCurrentPassCompleted()) {
        return
      }
      const list = (this.userItems || []).map(item => {
        let isPassVal = item.isPass
        if (isPassVal === true) isPassVal = 1
        if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
        if (isPassVal === '1') isPassVal = 1
        if (isPassVal === '0') isPassVal = 0
        return {
          isPass: Number(isPassVal) || 0,
          notPassReason: item.notPassReason || '',
          userId: item.userId,
          userName: item.userName
        }
      })
      saveStepPassInfoPer({
        list: list, // 评标结果
        stepId: this.stepId, // 评审步骤id
        stepReviewId: this.selectedUnit, // 评审项id
        sectionCode: Cookies.get('pushSectionCode'),
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          if (nextStepReviewId) {
            this.getStepPassInfo(nextStepReviewId)
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error('保存评审结果失败')
      })
    },
    // ==================== 单行通过式评审自动保存 ====================

    // 点击 √ 或 × 时立即保存
    handleIsPassChange(item) {
      // 先清掉理由的防抖定时器（避免理由还在等待保存）
      if (this._notPassDebounceTimer) {
        clearTimeout(this._notPassDebounceTimer)
        this._notPassDebounceTimer = null
      }
      this.saveSingleUserReview(item)
    },

    // notPassReason 输入防抖保存
    handleNotPassReasonInput(item) {
      if (this._notPassDebounceTimer) {
        clearTimeout(this._notPassDebounceTimer)
      }
      this._notPassDebounceTimer = setTimeout(() => {
        this.saveSingleUserReview(item)
        this._notPassDebounceTimer = null
      }, 600)
    },

    // 调接口保存单个用户的一条评审记录
    saveSingleUserReview(item) {
      if (!item || !item.userId) return
      let isPassVal = item.isPass
      if (isPassVal === true) isPassVal = 1
      if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
      if (isPassVal === '1') isPassVal = 1
      if (isPassVal === '0') isPassVal = 0
      saveStepPassReview({
        sectionCode: Cookies.get('pushSectionCode'),
        stepId: this.stepId,
        stepReviewId: this.selectedUnit,
        isPass: Number(isPassVal) || 0,
        notPassReason: item.notPassReason || '',
        userId: item.userId,
        userName: item.userName || ''
      }).catch(() => { })
    },
    // 打分：分数输入立即保存
    handleScoreChange(item) {
      if (this._scoreDebounceTimer) {
        clearTimeout(this._scoreDebounceTimer)
        this._scoreDebounceTimer = null
      }
      this.saveSingleScoreReview(item)
    },
    // 打分：理由输入防抖保存
    handleScoreReasonInput(item) {
      if (this._scoreDebounceTimer) {
        clearTimeout(this._scoreDebounceTimer)
        this._scoreDebounceTimer = null
      }
      this._scoreDebounceTimer = setTimeout(() => {
        this.saveSingleScoreReview(item)
        this._scoreDebounceTimer = null
      }, 600)
    },
    // 打分：保存单个用户打分记录
    saveSingleScoreReview(item) {
      if (!item || !item.userId) return
      saveStepScoreReview({
        sectionCode: Cookies.get('pushSectionCode'),
        stepId: this.stepId,
        stepScoreId: this.selectedUnit,
        score: item.score != null && item.score !== '' ? Number(item.score) : null,
        scoreReason: item.scoreReason || '',
        userId: item.userId,
        userName: item.userName || ''
      }).catch(() => { })
    },

    // 保存打分式评审结果（单步骤）
    saveStepScoreInfoPer(nextStepReviewId) {
      // 校验当前所有用户是否都完成了打分
      if (!this.validateCurrentScoreCompleted()) {
        return
      }
      let data = {
        list: this.userItems,
        stepId: this.stepId,
        stepScoreId: this.selectedUnit,
        sectionCode: Cookies.get('pushSectionCode'),
      }
      saveStepScoreInfoPer(data).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          if (nextStepReviewId) {
            // 打分式评审保存后，跳转到下一打分项，先获取评审规则
            this.getStepScoreRule(nextStepReviewId)
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error('保存评审结果失败')
      })
    },
    // 校验当前右侧单项打分是否都完成
    validateCurrentScoreCompleted() {
      const scoreRule = this.scoreRuleSource.scoreRule || ''
      const { allowedValues, ranges } = this.parseScoreRule(scoreRule)

      for (const item of (this.userItems || [])) {
        // 检查是否为空
        if (item.score === undefined || item.score === null || item.score === '') {
          this.$message.error('请完成所有用户的打分')
          return false
        }
        const score = Number(item.score)
        if (isNaN(score)) {
          this.$message.error('分数必须是有效数字')
          return false
        }
        // 检查是否有错误
        if (item.scoreError) {
          this.$message.error('请修正打分错误后再保存')
          return false
        }
        // 检查分数是否在允许范围内
        if (scoreRule && !this.isScoreAllowed(score, allowedValues, ranges)) {
          this.$message.error('存在不符合打分规则的分数，请修正后再保存')
          return false
        }
        // 检查需要理由时是否填写了理由
        if (item.needReason) {
          if (!item.scoreReason || !item.scoreReason.trim()) {
            this.$message.error('需要填写理由的请填写评审意见')
            return false
          }
        }
      }
      return true
    },
    // 打分数明细
    getStepScoreRule(value) {
      getStepScoreRule({ scoreStepId: value }).then(res => {
        if (res.code === 200) {
          console.log('--------打分明细');
          console.log(res);
          console.log('--------打分明细');

          this.getStepScoreInfo(value)
          this.scoreRuleSource = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //获取打分项信息
    getStepScoreInfo(value) {
      getStepScoreInfo({ stepId: this.stepId, stepScoreId: value, sectionCode: this.sectionCode, orderNum: this.orderNum }).then(res => {
        if (res.code === 200) {
          this.selectedUnit = value
          this.previous = res.data.previous
          this.next = res.data.next
          const list = res.data.userItems || []
          this.userItems = list.map(item => {
            return Object.assign({}, item, {
              needReason: !!(item.needReason || item.scoreReason),
              scoreReason: item.scoreReason || ''
            })
          })
          this.userItems.forEach(u => {
            this.validateScoreChange(u)
          })
          // 更新评审标准
          const currentUnit = this.unitOptions.find(item => item.id === value)
          if (currentUnit) {
            this.reviewStandard = currentUnit.reviewStandard
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 通过式评审生效列表
    postStepPassInfoList() {
      postStepPassInfoList({ stepId: this.stepId, sectionCode: Cookies.get('pushSectionCode'), orderNum: this.orderNum }).then(res => {
        if (res.code === 200) {
          const data = res.data || {}
          console.log(JSON.stringify(res.data));

          this.buildReviewEffectiveTable(data.titles, data.values)
        } else {
          this.reviewEffectiveTableData = []
          this.reviewEffectiveTitles = []
          this.$message.error(res.msg)
        }
      })
    },
    // 打分式评审生效列表
    getStepScoreInfoList() {
      getStepScoreInfoList({ stepId: this.stepId, sectionCode: this.sectionCode, orderNum: this.orderNum }).then(res => {
        if (res.code === 200) {
          const data = res.data || {}
          this.buildReviewEffectiveTable(data.titles, data.values)
        } else {
          this.reviewEffectiveTableData = []
          this.reviewEffectiveTitles = []
          this.$message.error(res.msg)
        }
      })
    },
    //  提交按钮
    submit() {
      switch (this.stepTypeCode) {
        case '01':
          this.submitStep()
          this.saveStepPassInfoPer()
          break;
        case '02':
          this.submitStepScore()
          this.saveStepScoreInfoPer()
          break;
        default:
          break;
      }
    },
    //提交步骤(通过式评审)
    submitStep() {
      submitStep({
        stepId: this.stepId,
        sectionCode: this.sectionCode,
      }).then(res => {
        if (res.code != 200) {
          this.$message.error(res.msg)
        }
      })
    },
    //提交步骤(打分式评审)
    submitStepScore() {
      submitStepScore({
        stepId: this.stepId,
        sectionCode: this.sectionCode,
        stepScoreId: this.selectedUnit
      }).then(res => {
        if (res.code != 200) {
          this.$message.error(res.msg)
        }
      })
    },
    /* ==================== 页面操作 ==================== */
    handleClose() {
      if (this.isEmbedded) {
        this.$emit('close')
        return
      }
      this.$router.go(-1)
    },
    handleBidderChange(value) {
      this.loadBidderAssets(value)
      this.fetchPdfTotalPages(value)
    },
    fetchPdfTotalPages(userId) {
      if (!userId) return
      getPdfTotalPages({
        sectionCode: this.sectionCode,
        userId: userId,
        isBlind: this.isBlindReview ? 1 : 0
      }).then(res => {
        if (res.code === 200) {
          this.pdfTotalPages = res.data || 0
        }
      })
    },

    /* ==================== PDF 相关 ==================== */
    onPdfLoaded(data) {
      // PDF加载完成回调
    },
    onPdfError(error) {
      // 如果是渲染取消错误，尝试重新加载
      if (error.name === 'RenderingCancelledException') {
        this.$nextTick(() => {
          // 延迟重新设置PDF URL来触发重新加载
          const currentUrl = this.pdfUrl
          this.pdfUrl = ''
          setTimeout(() => {
            this.pdfUrl = currentUrl
          }, 100)
        })
      } else {
        // this.$message.error('PDF文件加载失败，请检查文件是否存在')
      }
    },

    /* ==================== 评审生效弹窗 ==================== */
    handleOneClickPass() {
      if (this.stepTypeCode == '01' && !this.reviewEffectiveDialogVisible) {
        ; (this.userItems || []).forEach(item => {
          item.isPass = 1
          item.notPassReason = ''
        })
        this.$message.success('已设置当前评审项全部为通过')
        return
      }

      const userIdKey = '_userId'
      const userNameKey = '0'
      const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
        return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
      })
        ; (this.reviewEffectiveTableData || []).forEach(row => {
          const hasUser = row[userIdKey] || row[userNameKey]
          if (!hasUser) return
          reviewCols.forEach(col => {
            row[col.itemKey] = '1'
            row[col.itemKey + '_notPassReason'] = ''
          })
        })
      this.$message.success('已设置所有评审项为通过')
    },
    // 提交生效
    handleSubmitEffective() {
      // 校验所有人是否都完成了评审
      if (!this.validateAllEffectiveCompleted()) {
        return
      }
      if (this.stepTypeCode == "01") {
        this.saveStepPassInfo(false)
      } else if (this.stepTypeCode == "02") {
        this.saveStepScoreInfoAll(false)
      }
    },
    // 校验评审生效弹窗中所有人是否都完成了评审
    validateAllEffectiveCompleted() {
      const userIdKey = '_userId'
      const userNameKey = '0'
      const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
        return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
      })

      if (this.stepTypeCode == "01") {
        // 通过式评审：检查所有单元格是否都有值（通过/不通过）
        for (const row of (this.reviewEffectiveTableData || [])) {
          for (const col of reviewCols) {
            const val = row[col.itemKey]
            if (val === undefined || val === null || val === '') {
              this.$message.error('请完成所有评审项的评审')
              return false
            }
            // 如果不通过，检查是否填写了理由
            if (val === 0 || val === '0' || val === false) {
              const reason = row[col.itemKey + '_notPassReason']
              if (!reason || !reason.trim()) {
                this.$message.error('不通过的评审项请填写评审意见')
                return false
              }
            }
          }
        }
      } else if (this.stepTypeCode == "02") {
        // 打分式评审：检查所有分数是否都已填写且有效
        for (const row of (this.reviewEffectiveTableData || [])) {
          for (const col of reviewCols) {
            // 从 col.rule 获取当前列的规则
            const scoreRule = col.rule || ''
            const { allowedValues, ranges } = this.parseScoreRule(scoreRule)

            const val = row[col.itemKey]
            // 检查是否为空
            if (val === undefined || val === null || val === '') {
              this.$message.error('请完成所有评审项的打分')
              return false
            }
            const score = Number(val)
            if (isNaN(score)) {
              this.$message.error('分数必须是有效数字')
              return false
            }
            // 检查是否有错误
            const errorFlagKey = col.itemKey + '_scoreError'
            if (row[errorFlagKey]) {
              this.$message.error('请修正打分错误后再提交')
              return false
            }
            // 检查分数是否在允许范围内
            if (scoreRule && !this.isScoreAllowed(score, allowedValues, ranges)) {
              this.$message.error('存在不符合打分规则的分数，请修正后再提交')
              return false
            }
            // 检查需要理由时是否填写了理由
            const needFlagKey = col.itemKey + '_needReason'
            if (row[needFlagKey]) {
              const reason = row[col.itemKey + '_reason']
              if (!reason || !reason.trim()) {
                this.$message.error('需要填写理由的评审项请填写评审意见')
                return false
              }
            }
          }
        }
      }
      return true
    },
    //保存通过式评审结果（评审生效）
    saveStepPassInfo(isClose) {
      const userIdKey = '_userId'
      const userNameKey = '0'
      const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
        return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
      })
      const list = [];
      (this.reviewEffectiveTableData || []).forEach(row => {
        const userId = row[userIdKey]
        const userName = row[userNameKey]
        if (!userId && !userName) return
        reviewCols.forEach(col => {
          let isPassVal = row[col.itemKey]
          if (isPassVal === true) isPassVal = 1
          if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
          if (isPassVal === '1') isPassVal = 1
          if (isPassVal === '0') isPassVal = 0
          list.push({
            stepReviewId: col.stepReviewId,
            userId: userId,
            userName: userName,
            isPass: Number(isPassVal) || 0,
            notPassReason: row[col.itemKey + '_notPassReason'] || ''
          })
        })
      })
      let params = {
        list: list,
        stepId: this.stepId,
        isClose: isClose,
        sectionCode: Cookies.get('pushSectionCode'),
        orderNum: this.orderNum,
      }
      return saveStepPassInfo(params).then(res => {
        if (res.code === 200) {
          if (!isClose) {
            this.$message.success('评审结果已提交生效')
            // this.reviewEffectiveDialogVisible = false
            // 返回上个页面
            this.$router.go(-1)
          }
          this.getStepDetailByStepId()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //存通过式评审结果（全部）
    saveStepScoreInfoAll(isClose) {
      const userIdKey = '_userId'
      const userNameKey = '0'
      const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
        return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
      })
      const list = [];
      (this.reviewEffectiveTableData || []).forEach(row => {
        const userId = row[userIdKey]
        const userName = row[userNameKey]
        if (!userId && !userName) return
        reviewCols.forEach(col => {
          // 打分式评审：该列为分数
          const scoreVal = row[col.itemKey]
          const scoreNum = scoreVal === '' || scoreVal === null || typeof scoreVal === 'undefined'
            ? null
            : Number(scoreVal)
          const reason = row[col.itemKey + '_reason'] || ''
          list.push({
            stepReviewId: col.stepReviewId,
            userId: userId,
            userName: userName,
            score: isNaN(scoreNum) ? 0 : scoreNum,
            scoreReason: reason,
            orderNum: this.orderNum
          })
        })
      })
      let params = {
        list: list,
        stepId: this.stepId,
        isClose: isClose,
        sectionCode: Cookies.get('pushSectionCode')
      }
      return saveStepScoreInfoAll(params).then(res => {
        if (res.code === 200) {
          if (!isClose) {
            this.$message.success('评审结果已提交生效')
            this.reviewEffectiveDialogVisible = false
            // 返回上个页面
            this.$router.go(-1)
          }
          this.getStepDetailByStepId()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 点击章节目录跳转到对应PDF页码
    handleCatalogueClick(data) {
      if (data.pageNum && this.$refs.pdfViewer) {
        this.$refs.pdfViewer.goToPage(data.pageNum)
      }
    },

    // 页面改变
    onPageChanged(data) {
      console.log('页面改变:', data)
    },

    // 缩放改变
    onScaleChanged(scale) {
      console.log('缩放改变:', scale)
    },
    // 评审生效
    handleReviewEffective() {
      // 打开前刷新一次评审生效列表
      if (this.stepTypeCode == "01") {
        this.postStepPassInfoList()
      } else if (this.stepTypeCode == "02") {
        this.getStepScoreInfoList()
        // 确保已有打分规则，避免弹窗中打分时规则为空导致不触发“需要理由”
        if (!this.scoreRuleSource || !this.scoreRuleSource.scoreType) {
          const sid = this.selectedUnit
          if (sid) {
            this.getStepScoreRule(sid)
          }
        }
      }
      this.effectiveActiveColumnKey = ''
      this.effectiveActiveItemId = ''
      this.effectiveReviewStandard = ''
      this.effectiveReviewRule = ''
      this.reviewEffectiveDialogVisible = true
    },
    // 关闭评审生效弹窗
    async handleReviewEffectiveDialogClose(done) {
      // // 关闭和X时调用all/save接口（isClose: true），不再调用per/save接口
      // if (this.reviewEffectiveDialogVisible) {
      //   if (this.stepTypeCode == '01') {
      //     await this.saveStepPassInfo(true)
      //   } else if (this.stepTypeCode == '02') {
      //     await this.saveStepScoreInfoAll(true)
      //   }
      // }
      this.reviewEffectiveDialogVisible = false
      this.effectiveReviewStandard = ''
      this.effectiveReviewRule = ''
      this.effectiveActiveColumnKey = ''
      this.effectiveActiveItemId = ''
      console.log(done);

      // 根据类型刷新对应的数据接口
      if (this.selectedUnit) {
        if (this.stepTypeCode === '01') {
          this.getStepPassInfo(this.selectedUnit)
        } else if (this.stepTypeCode === '02') {
          this.getStepScoreInfo(this.selectedUnit)
        }
      }

      if (typeof done === 'function') {
        done()
      }
    },
    // 构建评审生效表格
    buildReviewEffectiveTable(titles, values) {
      const t = titles || []
      const v = values || []
      this.reviewEffectiveTitles = t
      if (!t.length || !v.length) {
        this.reviewEffectiveTableData = []
        return
      }
      const userMap = {}
      v.forEach(colValues => {
        if (!Array.isArray(colValues)) return
        colValues.forEach(cell => {
          if (!cell || !cell.userId) return
          const uid = cell.userId
          if (!userMap[uid]) {
            userMap[uid] = { _userId: uid }
          }
          const row = userMap[uid]
          const key = cell.itemKey
          if (typeof key !== 'undefined') {
            row[key] = (cell.value !== undefined && cell.value !== null) ? cell.value : ''
            if (typeof cell.notPassReason !== 'undefined' && cell.notPassReason !== null) {
              row[key + '_notPassReason'] = cell.notPassReason
            }
            if (typeof cell.scoreReason !== 'undefined' && cell.scoreReason !== null) {
              row[key + '_reason'] = cell.scoreReason
              if (cell.scoreReason !== '') {
                row[key + '_needReason'] = true
              }
            }
            if (key === '0') {
              row._userName = (cell.value !== undefined && cell.value !== null) ? cell.value : ''
              // 初始化 row['0'] 为空字符串，v-model 输入时写入分数，不与公司名冲突
              if (!Object.prototype.hasOwnProperty.call(row, '0')) row['0'] = ''
            }
          }
        })
      })
      const nameKey = '0'
      let rows = Object.values(userMap)
      if (t.some(tt => tt.itemKey === nameKey)) {
        const nameColumns = v.filter(colValues => Array.isArray(colValues) && colValues.some(c => c.itemKey === nameKey))
        const bestNameColumn = nameColumns
          .map(colValues => {
            const validNameCount = colValues.filter(c => c && c.itemKey === nameKey && c.userId && c.value !== null && c.value !== '').length
            return {
              colValues,
              validNameCount,
              totalCount: colValues.length
            }
          })
          .sort((a, b) => {
            if (b.validNameCount !== a.validNameCount) {
              return b.validNameCount - a.validNameCount
            }
            return b.totalCount - a.totalCount
          })[0]
        if (bestNameColumn && Array.isArray(bestNameColumn.colValues)) {
          const orderedUserIds = bestNameColumn.colValues.map(c => c.userId)
          rows = orderedUserIds
            .filter((uid, idx) => !!uid && orderedUserIds.indexOf(uid) === idx)
            .map(uid => userMap[uid])
            .filter(r => !!r)
        }
      }
      // 预初始化所有动态 key，确保 Vue 2 能对其建立响应式观测
      // 若属性在赋值给 reviewEffectiveTableData 前不存在，v-model 写入时会绕过响应式，导致部分浏览器重渲染时输入被清空
      rows.forEach(row => {
        t.forEach(col => {
          if (col.itemKey === '0') return
          const k = col.itemKey
          // 主值：如果没有选过则保持空（不给默认值）
          if (!Object.prototype.hasOwnProperty.call(row, k)) row[k] = ''
          if (!Object.prototype.hasOwnProperty.call(row, k + '_reason')) row[k + '_reason'] = ''
          if (!Object.prototype.hasOwnProperty.call(row, k + '_notPassReason')) row[k + '_notPassReason'] = ''
          if (!Object.prototype.hasOwnProperty.call(row, k + '_needReason')) row[k + '_needReason'] = false
          if (!Object.prototype.hasOwnProperty.call(row, k + '_scoreError')) row[k + '_scoreError'] = ''
        })
      })
      this.reviewEffectiveTableData = rows
      const activeColumn = t.find(col => String(this.getEffectiveColumnItemId(col)) === String(this.effectiveActiveItemId))
      if (activeColumn) {
        this.setEffectiveActiveColumn(activeColumn)
      }
    },
    // 处理评审生效弹窗中的打分输入逻辑（按单元格维度）- 校验
    validateEffectiveScoreChange(row, colKey) {
      // 从 reviewEffectiveTitles 中获取当前列的 rule 和 scoreReasonType
      const colTitle = (this.reviewEffectiveTitles || []).find(t => t.itemKey === colKey)
      const scoreRule = colTitle && colTitle.rule ? colTitle.rule : ''
      const scoreReasonType = colTitle && colTitle.scoreReasonType != null ? Number(colTitle.scoreReasonType) : 0
      const needFlagKey = colKey + '_needReason'
      const errorFlagKey = colKey + '_scoreError'

      // 如果没有 scoreRule，不做校验
      if (!scoreRule || !scoreRule.trim()) {
        this.$set(row, needFlagKey, false)
        this.$set(row, errorFlagKey, '')
        return
      }

      // 解析 scoreRule
      const { maxScore, allowedValues, ranges } = this.parseScoreRule(scoreRule)

      const raw = row[colKey]
      // 空值处理
      if (raw === '' || raw === null || typeof raw === 'undefined') {
        this.$set(row, needFlagKey, false)
        this.$set(row, errorFlagKey, '')
        return
      }

      let score = Number(raw)
      // 非数字处理
      if (isNaN(score)) {
        this.$notify({
          title: '打分有误',
          message: '请输入有效数字',
          type: 'error',
        })
        this.$set(row, errorFlagKey, '请输入有效数字')
        this.$set(row, needFlagKey, false)
        return
      }

      // 限制最大值
      if (score > maxScore) {
        const errorMessage = '超过打分最大分值' + maxScore
        this.$set(row, colKey, '')
        this.$set(row, errorFlagKey, errorMessage)
        this.$set(row, needFlagKey, false)
        this.$notify({
          title: '打分有误',
          message: errorMessage,
          type: 'error',
        })
        return
      }

      // 限制最小值（不能为负数）
      if (score < 0) {
        const errorMessage = '分数不能为负数'
        this.$set(row, colKey, '')
        this.$set(row, errorFlagKey, errorMessage)
        this.$set(row, needFlagKey, false)
        this.$notify({
          title: '打分有误',
          message: errorMessage,
          type: 'error',
        })
        return
      }

      // 检查分数是否在允许范围内
      if (!this.isScoreAllowed(score, allowedValues, ranges)) {
        let hint = ''
        if (allowedValues.length > 0 && ranges.length > 0) {
          hint = `只能输入 ${allowedValues.join('、')} 或 ${ranges.map(r => r[0] + '-' + r[1]).join('、')} 区间内的分数`
        } else if (allowedValues.length > 0) {
          hint = `只能输入 ${allowedValues.join('、')} 中的一个`
        } else if (ranges.length > 0) {
          hint = `只能输入 ${ranges.map(r => r[0] + '-' + r[1]).join('、')} 区间内的分数`
        }
        this.$notify({
          title: '打分有误',
          message: hint,
          type: 'error',
        })
        this.$set(row, errorFlagKey, hint)
        this.$set(row, needFlagKey, false)
      } else {
        this.$set(row, errorFlagKey, '')
      }

      // 根据 scoreReasonType 判断是否需要输入理由
      this.$set(row, needFlagKey, false)
      if (scoreReasonType === 1) {
        if (score === 0) this.$set(row, needFlagKey, true)
      } else if (scoreReasonType === 2) {
        if (score !== maxScore) this.$set(row, needFlagKey, true)
      } else if (scoreReasonType === 3) {
        this.$set(row, needFlagKey, true)
      } else if (scoreReasonType === 4) {
        this.$set(row, needFlagKey, false)
      }
    },

    /* ==================== 分数校验工具方法 ==================== */
    parseScoreRule(scoreRule) {
      if (!scoreRule || typeof scoreRule !== 'string') {
        return { maxScore: 0, allowedValues: [], ranges: [] }
      }
      const trimmed = scoreRule.trim()
      if (!trimmed) {
        return { maxScore: 0, allowedValues: [], ranges: [] }
      }
      const parts = trimmed.split(',')
      const allowedValues = [] // 固定分值
      const ranges = [] // 区间 [start, end]
      let maxScore = 0
      for (const part of parts) {
        const p = part.trim()
        if (!p) continue
        if (p.includes('-')) {
          const [startStr, endStr] = p.split('-')
          const start = parseInt(startStr, 10)
          const end = parseInt(endStr, 10)
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push([start, end])
            if (end > maxScore) maxScore = end
          }
        } else {
          const num = parseInt(p, 10)
          if (!isNaN(num)) {
            allowedValues.push(num)
            if (num > maxScore) maxScore = num
          }
        }
      }
      return { maxScore, allowedValues, ranges }
    },
    isScoreAllowed(score, allowedValues, ranges) {
      // 检查是否在固定分值中
      if (allowedValues.includes(score)) return true
      // 检查是否在任意区间内
      for (const [start, end] of ranges) {
        if (score >= start && score <= end) return true
      }
      return false
    },

    /* ==================== 右侧单项打分 ==================== */
    // 校验分数合法性（保留原逻辑，不做保存）
    validateScoreChange(item) {
      const scoreRule = this.scoreRuleSource.scoreRule || ''
      const scoreReasonType = Number(this.scoreRuleSource.scoreReasonType) || 0

      // 如果没有 scoreRule，不做校验
      if (!scoreRule || !scoreRule.trim()) {
        item.needReason = false
        item.scoreError = ''
        return
      }

      // 解析 scoreRule
      const { maxScore, allowedValues, ranges } = this.parseScoreRule(scoreRule)
      const raw = item.score
      // 空值处理
      if (raw === '' || raw === null || typeof raw === 'undefined') {
        item.needReason = false
        item.scoreError = ''
        return
      }
      let score = Number(raw)
      // 非数字处理
      if (isNaN(score)) {
        this.$notify({
          title: '打分有误',
          message: '请输入有效数字',
          type: 'error',
        })
        item.scoreError = '请输入有效数字'
        item.needReason = false
        return
      }

      // 限制最大值
      if (score > maxScore) {
        const errorMessage = '超过打分最大分值' + maxScore
        item.score = ''
        item.scoreError = errorMessage
        item.needReason = false
        this.$notify({
          title: '打分有误',
          message: errorMessage,
          type: 'error',
        })
        return
      }

      // 限制最小值（不能为负数）
      if (score < 0) {
        const errorMessage = '分数不能为负数'
        item.score = ''
        item.scoreError = errorMessage
        item.needReason = false
        this.$notify({
          title: '打分有误',
          message: errorMessage,
          type: 'error',
        })
        return
      }

      // 检查分数是否在允许范围内
      if (!this.isScoreAllowed(score, allowedValues, ranges)) {
        // 生成提示信息
        let hint = ''
        if (allowedValues.length > 0 && ranges.length > 0) {
          // 混合格式，如 0,5-10
          hint = `只能输入 ${allowedValues.join('、')} 或 ${ranges.map(r => r[0] + '-' + r[1]).join('、')} 区间内的分数`
        } else if (allowedValues.length > 0) {
          // 纯固定分，如 3,4,5
          hint = `只能输入 ${allowedValues.join('、')} 中的一个`
        } else if (ranges.length > 0) {
          // 纯区间，如 5-10
          hint = `只能输入 ${ranges.map(r => r[0] + '-' + r[1]).join('、')} 区间内的分数`
        }
        this.$notify({
          title: '打分有误',
          message: hint,
          type: 'error',
        })
        item.scoreError = hint
        item.needReason = false
      } else {
        item.scoreError = ''
      }

      // 根据 scoreReasonType 判断是否需要输入理由
      item.needReason = false
      if (scoreReasonType === 1) {
        // 1. 评0分时需要输入理由
        if (score === 0) item.needReason = true
      } else if (scoreReasonType === 2) {
        // 2. 未评满分时需要输入理由
        if (score !== maxScore) item.needReason = true
      } else if (scoreReasonType === 3) {
        // 3. 评任何分数都需要输入理由
        item.needReason = true
      } else if (scoreReasonType === 4) {
        // 4. 无论评多少分都不需要输入
        item.needReason = false
      }
    },

    // 打开附件查看弹窗
    async openAttachmentViewByUserId(userId) {
      if (!userId) {
        this.$message.warning('请先选择投标单位')
        return
      }
      this.attachmentViewList = []
      this.attachmentViewDialogVisible = true
      try {
        const res = await getBidderAttachment({
          sectionCode: this.sectionCode,
          userId
        })
        if (res.code === 200) {
          this.attachmentViewList = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error(res.msg || '获取附件列表失败')
        }
      } catch (error) {
        console.error('获取附件列表失败:', error)
        this.$message.error('获取附件列表失败')
      }
    },

    // 下载附件文件
    handleFileDownload(file) {
      console.log(file);
      if (!file || !file.fileUrl) {
        this.$message.warning('文件链接不存在')
        return
      }
      const link = document.createElement('a')
      link.href = file.fileUrl
      link.download = file.fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  }
}
</script>

<style scoped lang="less">
/* 自定义评审项下拉 */
.unit-select-custom {
  position: relative;
  width: 100%;
}

.usc-trigger {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 36px;
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s;
  gap: 6px;

  &:hover {
    border-color: #c0c4cc;
  }

  &.is-open {
    border-color: #409eff;
  }

  .usc-value {
    flex: 1;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    word-break: break-all;
    white-space: normal;
  }

  .usc-placeholder {
    flex: 1;
    font-size: 14px;
    color: #c0c4cc;
    line-height: 1.6;
  }

  .usc-arrow {
    flex-shrink: 0;
    font-size: 14px;
    color: #c0c4cc;
    margin-top: 3px;
    transition: transform 0.3s;

    &.is-open {
      transform: rotate(180deg);
    }
  }
}

.usc-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 2000;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  max-height: 280px;
  overflow-y: auto;
}

.usc-option {
  padding: 8px 12px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  word-break: break-all;
  white-space: normal;
  cursor: pointer;

  &:hover {
    background: #f5f7fa;
  }

  &.is-selected {
    color: #409eff;
    font-weight: 500;
    background: #f0f7ff;
  }
}

.usc-empty {
  padding: 10px 12px;
  font-size: 14px;
  color: #c0c4cc;
  text-align: center;
}

.qualification-review-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

/* 顶部导航栏 */
.top-navbar {
  height: 60px;
  background-color: #e6f7ff;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 20px;
  border-bottom: 1px solid #d9d9d9;

}

.navbar-left {
  margin: 0px auto;
}

.bidder-select {
  width: 200px;
}

.bidder-select .el-input__inner {
  border-color: #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}

.bidder-select .el-input__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}



/* 主体内容区域 */
.main-content {
  flex: 1;
  display: flex;
  height: calc(100vh - 60px);
}

/* 左侧章节视图 */
.left-sidebar {
  width: 200px;
  background-color: white;
  border-right: 1px solid #e4e7ed;
  padding: 20px;
}

.chapter-view h3 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px 0;
}

.catalogue-Name {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
  display: inline-block;
  cursor: pointer;
}

.catalogue-Name:hover {
  overflow: visible;
  white-space: normal;
  word-break: break-all;
  z-index: 999;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 4px 8px;
  border-radius: 4px;
  position: relative;
}

.chapter-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chapter-item {
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  color: #666;
  padding: 8px 12px;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
  user-select: none;
}

.chapter-item.active {
  background-color: #1890ff;
  color: white;
}

.chapter-item:hover {
  background-color: #40a9ff;
  color: white;
}

/* 中间PDF预览区域 */
.pdf-preview-area {
  flex: 1;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* 右侧资格审查区域 */
.right-sidebar {
  width: 400px;
  background-color: white;
  border-left: 1px solid #e4e7ed;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.qualification-review {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.qualification-review h3 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px 0;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.review-header h3 {
  margin: 0;
}

.review-fixed-section {
  flex: 0 0 auto;
}

.review-scroll-section {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.review-scroll-section::-webkit-scrollbar {
  width: 6px;
}

.review-scroll-section::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.review-scroll-section::-webkit-scrollbar-track {
  background: transparent;
}

.unit-selection {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background-color: #f9f9f9;
}

.selection-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

:deep(.unit-select-popper) {
  width: 50px !important;

  .el-select-dropdown__item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 统一评审标准区域 */
.review-standard-box {
  margin: 12px 0 20px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  background-color: #f9fafc;
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  color: #606266;
}

.review-standard-title {
  flex: 0 0 auto;
  font-weight: 600;
  color: #303133;
  margin-right: 8px;
}

.review-standard-content {
  flex: 1 1 auto;
  line-height: 1.6;
  word-break: break-all;
  text-align: start;
}

.expert-scoring {
  padding: 8px 4px 4px;
}

.scoring-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 6px;
  text-align: left;
}

.scoring-subtitle {
  font-size: 13px;
  line-height: 1.6;
  color: #6b7280;
  margin-bottom: 18px;
}

.scoring-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.company-score-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  transition: all 0.2s ease;
}

.company-score-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.company-score-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(90deg, #f8fbff 0%, #f3f6fb 100%);
  border-bottom: 1px solid #edf2f7;
}

.company-score-body {
  padding: 16px;
}

.score-input {
  width: 100%;
}

.score-error {
  margin-top: 8px;
  padding: 8px 10px;
  font-size: 12px;
  color: #dc2626;
  line-height: 1.5;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
}

.score-input ::v-deep .el-input__inner {
  height: 42px;
  border-radius: 12px 0 0 12px;
  border-color: #d1d5db;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.score-input ::v-deep .el-input-group__append {
  border-radius: 0 12px 12px 0;
  border-color: #d1d5db;
  background: #f8fafc;
  color: #4b5563;
  font-weight: 600;
}

.score-input ::v-deep .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.score-input ::v-deep .el-input.is-error .el-input__inner,
.score-input ::v-deep .el-input.is-error .el-input-group__append {
  border-color: #f56c6c;
}

.review-effective-table ::v-deep .el-input.is-error .el-input__inner {
  border-color: #f56c6c;
}

.review-effective-table .score-error {
  margin-left: 0;
  margin-top: 4px;
  text-align: center;
  padding: 0;
  background: transparent;
  border: none;
}

.company-label {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  min-width: 0;
  flex: 1;
  word-break: break-word;
}

.company-score-unit {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e8f3ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
}

.score-reason-block {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e5e7eb;
}

.score-reason-label {
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
}

.score-reason-input ::v-deep .el-textarea__inner {
  min-height: 88px;
  border-radius: 12px;
  border-color: #d1d5db;
  line-height: 1.7;
  padding: 10px 12px;
}

.score-reason-input ::v-deep .el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.review-item {
  margin-bottom: 30px;
  padding: 22px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.review-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.item-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.review-standard {
  font-size: 12px;
  color: #666;
}

@media (max-width: 768px) {
  .review-item {
    padding: 16px;
    border-radius: 12px;
  }

  .expert-scoring {
    padding: 0;
  }

  .scoring-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .company-score-header,
  .company-score-body {
    padding: 14px;
  }
}

.review-options {
  margin-bottom: 15px;
}

.review-options .el-radio-group {
  display: flex;
  gap: 20px;
}

.review-options .el-radio {
  margin-right: 0;
}

.radio-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.comment-area {
  margin-top: 10px;
}

.comment-area .el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  line-height: 1.5;
}

.comment-area .el-textarea__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 底部操作按钮 */
.action-buttons {
  flex: 0 0 auto;
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

.action-buttons .el-button {
  padding: 10px 20px;
  font-size: 14px;
}

/* 右下角浮动按钮 */
.floating-action-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-action-button .el-button {
  width: 50px;
  height: 50px;
  background-color: #ff6b35;
  border-color: #ff6b35;
  font-size: 20px;
}

.floating-action-button .el-button:hover {
  background-color: #ff8c5a;
  border-color: #ff8c5a;
}

/* 评审生效弹窗样式 */
.review-effective-dialog .el-dialog {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  max-height: none !important;
  border-radius: 0 !important;
}

.review-effective-dialog .el-dialog__header {
  display: none;
}

.review-effective-dialog .el-dialog__body {
  padding: 0 !important;
  height: 100vh;
  overflow: hidden;
}

.review-effective-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f4f7fb 0%, #eef3f9 100%);
}

.review-effective-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
  gap: 16px;
}

.header-left {
  min-width: 0;
}

.review-title {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.review-effective-subtitle {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #6b7280;
}

.header-right {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.one-click-pass-btn,
.close-btn,
.submit-effective-btn {
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}

.one-click-pass-btn,
.submit-effective-btn {
  background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
  border-color: #409eff;
  color: white;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18);
}

.close-btn {
  background: #ffffff;
  border-color: #d1d5db;
  color: #374151;
}

.one-click-pass-btn:hover,
.submit-effective-btn:hover {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  border-color: #60a5fa;
  color: white;
}

.close-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #111827;
}

.review-table-container {
  flex: 1;
  padding: 20px 24px 24px;
  overflow: auto;
}

.effective-review-standard {
  margin-bottom: 16px;
  padding: 16px 18px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #f8fbff;
}

.effective-review-standard-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.effective-review-standard-content {
  font-size: 14px;
  line-height: 22px;
  color: #606266;
  white-space: pre-wrap;
  word-break: break-word;
}

.review-effective-table {
  background: #ffffff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
}

.review-effective-table ::v-deep .el-table__header-wrapper th {
  background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%) !important;
  color: #374151 !important;
  font-size: 13px;
  font-weight: 700 !important;
  border-bottom: 1px solid #e5e7eb;
}

.review-effective-table ::v-deep .el-table__body tr>td {
  padding: 14px 10px;
  border-bottom: 1px solid #eef2f7;
  vertical-align: top;
}

.review-effective-table ::v-deep .el-table__body tr:hover>td {
  background: #f8fbff !important;
}

.review-effective-table ::v-deep .cell {
  padding-left: 8px;
  padding-right: 8px;
}

.company-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.company-name {
  font-size: 14px;
  color: #303133;
  text-align: center;
  line-height: 1.4;
}

.pass-all-btn {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.pass-all-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.review-effective-table .el-radio-group {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.review-effective-table .el-radio {
  margin-right: 0;
}

.review-effective-table ::v-deep .el-radio {
  margin-right: 0;
  padding: 8px 14px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #ffffff;
  transition: all 0.2s ease;
}

.review-effective-table ::v-deep .el-radio:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.review-effective-table ::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: #2563eb;
}

.review-effective-table ::v-deep .el-radio__inner {
  border-color: #cbd5e1;
}

.review-effective-table ::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #2563eb;
  border-color: #2563eb;
}

.review-effective-table ::v-deep .el-radio.is-checked {
  border-color: #93c5fd;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
}

.review-effective-table .el-radio__label {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
}

.effective-score-input {
  width: 100%;
  max-width: 160px;
  margin: 0 auto;
}

.effective-score-input ::v-deep .el-input__inner {
  height: 40px;
  border-radius: 12px 0 0 12px;
  border-color: #d1d5db;
  font-weight: 600;
  text-align: center;
}

.effective-score-input ::v-deep .el-input-group__append {
  border-radius: 0 12px 12px 0;
  border-color: #d1d5db;
  background: #f8fafc;
  color: #4b5563;
  font-weight: 600;
}

.effective-score-input ::v-deep .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.effective-reason-input {
  margin-top: 10px;
}

.effective-reason-input ::v-deep .el-textarea__inner {
  background: #fbfdff;
  border-radius: 12px;
  border-color: #d1d5db;
  min-height: 82px;
  line-height: 1.6;
  padding: 10px 12px;
}

.effective-reason-input ::v-deep .el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.cell-comment {
  margin-top: 10px;
  text-align: left;
}

@media (max-width: 768px) {
  .review-effective-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }

  .review-title {
    font-size: 22px;
  }

  .header-right {
    width: 100%;
    justify-content: flex-start;
  }

  .review-table-container {
    padding: 14px;
  }

  .review-effective-table {
    border-radius: 14px;
  }

  .effective-score-input {
    max-width: 100%;
  }
}
</style>